import { RightOutlined } from "@ant-design/icons";
import { Link, LinkProps } from "react-router-dom";
import styles from "./LinkWithArrow.module.scss";

export default function LinkWithArrow({ to, children, className, ...props }: LinkProps) {
  return (
    <Link
      className={`${styles.LinkWithArrow} ${styles.child}`}
      to={to}
      {...props}
    >
      <span className={styles.label}>{children}</span>
      <span className={styles.arrow}>
        <RightOutlined />
      </span>
    </Link>
  );
}
